export const CHANNELS_MAX_FORM_LIMIT = {
  name: 128,
  description: 256,
  start_message: 256,
};
